/**
 * Operator quote landing templates (/quote/:slug). IDs must match server user.quotePageTemplate enum.
 */
export const QUOTE_PAGE_TEMPLATE_IDS = ["classic", "meadow", "noir", "coastal", "sunrise"];

export const QUOTE_PAGE_TEMPLATE_OPTIONS = [
  {
    id: "classic",
    label: "Classic glass",
    description: "Photo hero with frosted headline card — the original Clibbins look.",
  },
  {
    id: "meadow",
    label: "Meadow",
    description: "Soft organic greens, airy layout, and calm typography.",
  },
  {
    id: "noir",
    label: "Noir",
    description: "Dark canvas, refined contrast, and a slim accent line.",
  },
  {
    id: "coastal",
    label: "Coastal",
    description: "Light, breezy blues and a wave motif for a fresh feel.",
  },
  {
    id: "sunrise",
    label: "Sunrise",
    description: "Warm gradient energy with bold, confident type.",
  },
];

export function normalizeQuotePageTemplate(id) {
  const s = typeof id === "string" ? id.trim().toLowerCase() : "";
  return QUOTE_PAGE_TEMPLATE_IDS.includes(s) ? s : "classic";
}
